// extracted by mini-css-extract-plugin
export default {"wrap":"Kp-z","logoContainer":"Lp-z","brandImg":"Mp-z","logoImg":"Np-z","logoButton":"Op-z"};